interface Props {
  nome: string;
  aoConfirmar: () => void;
  aoCancelar: () => void;
  salvando: boolean;
}

export default function ModalConfirmarCancelar({
  nome,
  aoConfirmar,
  aoCancelar,
  salvando,
}: Props) {
  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/30 sm:items-center sm:p-6">
      <div className="animate-modal-pop w-full max-w-sm rounded-t-lg bg-white p-6 sm:rounded-lg">
        <div className="flex justify-center">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-danger-100">
            <i className="ri-alert-line text-2xl text-danger-600" />
          </span>
        </div>
        <h3 className="mt-4 text-center text-lg font-medium text-foreground-950">
          Cancelar inscrição
        </h3>
        <p className="mt-2 text-center text-sm text-secondary-500">
          Cancelar a inscrição de{' '}
          <strong className="font-medium text-foreground-900">{nome}</strong>? A vaga volta a
          ficar disponível.
        </p>
        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={aoCancelar}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-md border border-secondary-300 bg-white px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
          >
            Voltar
          </button>
          <button
            type="button"
            onClick={aoConfirmar}
            disabled={salvando}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-md bg-danger-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-danger-700 disabled:opacity-60"
          >
            {salvando ? 'Cancelando…' : 'Cancelar'}
          </button>
        </div>
      </div>
    </div>
  );
}